import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from './Navbar/Topnavbar';
import Footer from './Navbar/Footer';
import Home from './Container/Home';
import Aboutus from './Container/Aboutus';
import Domestictranding from './Container/Domestictranding';
import InternationalTranding from './Container/InternationalTranding';
import Contactus from './Container/Contactus';

// Import product category components
import Product from './Container/Product';
import ProductCategories from "./Container/Product/ProductCatagory";
import AlloyMetalScrap from "./Container/Product/AlloyMetalScrap";
import NonAlloyMetalScrap from "./Container/Product/Non-Alloymetal";
import FerrousMetal from "./Container/Product/FerrousMetal";
import NonFerrousMetal from "./Container/Product/NonFerrousMetal";
import MixedScrap from "./Container/Product/MixedScrap";
import AgroProductsExport from "./Container/Product/AgroProductsExport";
import AgricultureCommodities from "./Container/Product/AgricultureCommodities";
import MedicalEquipment from "./Container/Product/MedicalEquipment";
function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<Aboutus />} />
        <Route path="/domestic-trading" element={<Domestictranding />} />
        <Route path="/international-trading" element={<InternationalTranding />} />
        <Route path="/contact" element={<Contactus />} />
        <Route path="/products" element={<Product />} />
        <Route path="/products/catagories" element={<ProductCategories />} />

        {/* Product category routes */}
        <Route path="/products/alloy-metal-scrap" element={<AlloyMetalScrap />} />
        <Route path="/products/non-alloy-metal-scrap" element={<NonAlloyMetalScrap />} />
        <Route path="/products/ferrous-metal" element={<FerrousMetal />} />
        <Route path="/products/non-ferrous-metal" element={<NonFerrousMetal />} />
        <Route path="/products/specialty-mixed-scrap" element={<MixedScrap />} />
        <Route path="/products/agro-products-export" element={<AgroProductsExport />} />
        <Route path="/products/agriculture-commodities" element={<AgricultureCommodities />} />
        <Route path="/products/medical-equipment" element={<MedicalEquipment />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
